import React, { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { SeoButton } from 'dibs-seo/exports/SeoButton';
import classnames from 'classnames';

import styles from './HpRespHeroBannerText.scss';

import { HpRespHeroBannerText_heroBannerSettings } from './__generated__/HpRespHeroBannerText_heroBannerSettings.graphql';
import { HpRespHeroBannerText_linkData } from './__generated__/HpRespHeroBannerText_linkData.graphql';

type Props = {
    heroBannerSettings: HpRespHeroBannerText_heroBannerSettings | null;
    linkData: HpRespHeroBannerText_linkData;
    cta: string | null;
};

const HpRespHeroBannerText: FC<Props> = ({ heroBannerSettings, linkData, cta }) => {
    const {
        contentPosition,
        textAlignment,
        contentColor,
        eyeBrowText,
        headerText,
        headerStyle,
        dekText,
        ctaStyle,
    } = heroBannerSettings || {};

    const textClasses = classnames(styles.text, {
        [styles.contentPositionRight]: contentPosition === 'right',
        [styles.textAlignCenter]: textAlignment === 'center',
        [styles.contentColorWhite]: contentColor === 'white',
    });

    const headerClasses = classnames(styles.header, { [styles.italic]: headerStyle === 'italic' });
    const ctaClasses = classnames(styles.cta, { [styles.outline]: ctaStyle === 'outline' });

    const linkPath = linkData?.path;

    return (
        <div className={textClasses}>
            <div className={styles.eyeBrow}>{eyeBrowText}</div>
            <div className={headerClasses}>{headerText}</div>
            <div className={styles.dek}>{dekText}</div>
            <div>
                {linkPath && cta && (
                    <SeoButton
                        dataTn="hero-banner-cta"
                        className={ctaClasses}
                        linkData={linkData}
                        type={ctaStyle === 'outline' ? 'secondary' : 'primary'}
                    >
                        {cta}
                    </SeoButton>
                )}
            </div>
        </div>
    );
};

export default createFragmentContainer(HpRespHeroBannerText, {
    heroBannerSettings: graphql`
        fragment HpRespHeroBannerText_heroBannerSettings on HeroBannerSettingsType {
            contentPosition
            textAlignment
            contentColor
            eyeBrowText
            headerText
            headerStyle
            dekText
            ctaStyle
        }
    `,
    linkData: graphql`
        fragment HpRespHeroBannerText_linkData on LinkData {
            path
            ...SeoButton_linkData
        }
    `,
});
